import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';

interface DialogDeleteProps {
  open: boolean;
  onYes: () => void;
  onNo: () => void;
}

export function DialogDelete({
  open,
  onYes,
  onNo,
}: Readonly<DialogDeleteProps>) {
  return (
    <Dialog open={open} onClose={onNo}>
      <DialogTitle>Delete</DialogTitle>
      <DialogContent>Do you really want to delete this?</DialogContent>
      <DialogActions>
        <Button onClick={onYes}>Yes</Button>
        <Button onClick={onNo}>No</Button>
      </DialogActions>
    </Dialog>
  );
}
